var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"skip-links-content",class:{
    'inside-container': _vm.insideContainer,
    'footer-skip-links': _vm.onTheBottom,
  }},[_c('ul',{staticClass:"skip-links",class:{ 'on-the-top': _vm.onTheTop, 'on-the-footer': _vm.onTheBottom }},[_vm._m(0),_vm._m(1),_vm._m(2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('a',{attrs:{"href":"#main-content"}},[_vm._v("Ir para o corpo do site")])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('a',{attrs:{"href":"#app"}},[_vm._v("Ir para o cabeçalho do site")])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('a',{attrs:{"href":"#footer"}},[_vm._v("Ir para o rodapé do site")])])
}]

export { render, staticRenderFns }